import { BASE_API_URL } from "utils/constants";
import { downloadFilePost, post } from '../../utils/api';
import { DataResponse } from "services/response";


// ================================BÁO CÁO CHI TIẾT CHIẾN DỊCH EVENT=================================================================
export interface CTCDEventReportModel {
  stt: number
  campaignCode: string
  campaignName: string
  contentName: string
  targetGroupName: string
  status: string
  lichGui: string
  createBy: string
  createTime: string
  typeContent: string
  totalSend: number
  alreadySend: number
  notSend: number
  alreadyOpenMail: number
  unfollow: number
}

// ============ Khai báo phương thức =====================

export interface IEventCampaignServices {
  //    lấy data bóa cáo chi tiết chiến dịch event
  getDataReportCTCDEvent(data: object): Promise<DataResponse<Array<CTCDEventReportModel>>>
  // export report
  exportReport(data: object): Promise<void>
}
// Hàm khởi tạo các phương thức của Báo cáo bảo hành và khiếu nại service
export function createEventCampaignServices(): IEventCampaignServices {
  return {
    getDataReportCTCDEvent: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-ctcdevent`, data))
        .data;
    },
    exportReport: async (data) => {
      return (
        await downloadFilePost(
          `Reports/export-excel-ctcdevent`, data))
    },

  };
}
